const SNIPCART_PAYMENT_URL = "https://payment.snipcart.com/";
export const PAYMENT_SESSION_URL = `${SNIPCART_PAYMENT_URL}/api/public/custom-payment-gateway/payment-session`;
export const PAYMENT_CARDS_URL = "/stripe/payment-cards";
export const PAYMENT_INTENTS_URL = "/stripe/payment-intent";
export const PAYMENT_CONFIRM_URL = "/snipcart-payment";
